import {Component, OnInit, ChangeDetectionStrategy} from "@angular/core";
import {Router} from "@angular/router";
import {NzMessageService} from "ng-zorro-antd/message";
import {lastValueFrom} from "rxjs";
import {PTPDepartmentDto, PerFormaAPIService} from "src/app/services/pfapi.service";

@Component({
    selector: "app-ptp-department",
    templateUrl: "./ptp-department.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PTPDepartmentComponent implements OnInit {
    constructor(
        private readonly api: PerFormaAPIService,
        private router: Router,
        private message: NzMessageService
    ) {}

    loading = true;
    departments: PTPDepartmentDto[] = [];

    async ngOnInit() {
        await this.getData();
    }

    getData = async () => {
        this.loading = true;
        try {
            this.departments = await lastValueFrom(this.api.getApiConfigurePtpDepartments());
        } catch (e) {
            this.message.error("Failed to fetch departments");
            console.log(e);
        } finally {
            this.loading = false;
        }
    };

    addDepartment = () => {
        this.router.navigateByUrl("/configure/ptpdepartmentcreate");
    };

    editDepartment = (id: number) => {
        this.router.navigate(["/configure/ptpdepartmentedit"], {queryParams: {id}});
    };

    deleteDepartment = async (id: number) => {
        this.loading = true;
        try {
            await lastValueFrom(this.api.deleteApiConfigurePtpDepartmentsId(id));
            this.message.success("Department deleted");
            await this.getData();
        } catch (e) {
            this.message.error("Failed to delete department");
            console.log(e);
            this.loading = false;
        }
    };
}
